import { render, staticRenderFns } from "./PaymentDocuments.vue?vue&type=template&id=77069b40&"
import script from "./PaymentDocuments.vue?vue&type=script&lang=ts&"
export * from "./PaymentDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports